import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Utils from '@/classes/Utils'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/login',
			name: 'login',
			component: () => import('./views/Login.vue'),
			meta: {
				title: 'ログイン',
			},
		},
		{
			path: '/staff-new',
			name: 'staff-new',
			component: () => import('./views/StaffNew.vue'),
			meta: {
				title: '新規登録',
			},
		},
		{
			path: '/staff-new/:teamId',
			name: 'staff-new-join-team',
			component: () => import('./views/StaffNew.vue'),
			meta: {
				title: '新規登録',
			},
		},
		{
			path: '/',
			name: 'top',
			component: () => import('./views/Top.vue'),
			meta: {
				requireAuth: true,
				title: 'ホーム',
				icon: 'home',
			},
		},
		{
			path: '/top/:token',
			name: 'app-top',
			component: () => import('./views/Top.vue'),
			meta: {
				title: 'ホーム',
				icon: 'home',
			},
		},
		{
			path: '/news',
			name: 'news',
			component: () => import('./views/News.vue'),
			meta: {
				requireAuth: true,
				title: 'みんなの記事',
				icon: 'news',
			},
		},
		{
			path: '/news/:token',
			name: 'app-news',
			component: () => import('./views/News.vue'),
			meta: {
				requireAuth: true,
				title: 'みんなの記事',
				icon: 'news',
			},
		},
		{// /news/newsIdで遷移後にリロードすると↑の/news/:tokenが先にマッチして
		// route.params.tokenにnewsIdが入ってしまいroute.params.newsIdはundefinedになる不具合。
		// routerの理解不足とWebView連携の設計ミスが原因。
		// ダミーの:tokenを挟むことで対応する。view側でnews-viewにpushしている部分は全て該当する。
			path: '/news/:token/:newsId',
			name: 'news-view',
			component: () => import('./views/NewsView.vue'),
			meta: {
				requireAuth: true,
				title: 'みんなの記事',
				icon: 'news',
			},
		},
		{
			path: '/news-new',
			name: 'news-new',
			component: () => import('./views/NewsEdit.vue'),
			meta: {
				requireAuth: true,
				title: '記事の投稿画面',
				icon: 'news_edit',
			},
		},
		{
			path: '/news-new/:token',
			name: 'app-news-new',
			component: () => import('./views/NewsEdit.vue'),
			meta: {
				requireAuth: true,
				title: '記事の投稿画面',
				icon: 'news_edit',
			},
		},
		{
			path: '/news-edit/:newsId',
			name: 'news-edit',
			component: () => import('./views/NewsEdit.vue'),
			meta: {
				requireAuth: true,
				title: '記事の投稿画面',
				icon: 'news_edit',
			},
		},
		{
			path: '/staff',
			name: 'my-page',
			component: () => import('./views/Staff.vue'),
			meta: {
				requireAuth: true,
				title: 'マイページ',
				icon: 'my_page',
			},
		},
		{
			path: '/staff/:token',
			name: 'app-my-page',
			component: () => import('./views/Staff.vue'),
			meta: {
				requireAuth: true,
				title: 'マイページ',
				icon: 'my_page',
			},
		},
		{// /staff/staffIdで遷移後にリロードすると↑の/staff/:tokenが先にマッチして
		// route.params.tokenにstaffIdが入ってしまいroute.params.staffIdはundefinedになる不具合。
		// routerの理解不足とWebView連携の設計ミスが原因。
		// ダミーの:tokenを挟むことで対応する。view側でstaffにpushしている部分は全て該当する。
		// パスが同じで引数が違うルートは同じことになるので注意。
			path: '/staff/:token/:staffId',
			name: 'staff',
			component: () => import('./views/Staff.vue'),
			meta: {
				requireAuth: true,
				title: 'メンバー紹介',
				icon: 'user',
			},
		},
		{
			path: '/team/:teamId',
			name: 'team',
			component: () => import('./views/Team.vue'),
			meta: {
				requireAuth: true,
				title: 'チーム紹介',
				icon: 'team',
			},
		},
		{
			path: '/team-new',
			name: 'team-new',
			component: () => import('./views/TeamEdit.vue'),
			meta: {
				requireAuth: true,
				title: 'チームを作る',
				icon: 'team',
			},
		},
		{
			path: '/team-new/:token',
			name: 'app-team-new',
			component: () => import('./views/TeamEdit.vue'),
			meta: {
				requireAuth: true,
				title: 'チームを作る',
				icon: 'team',
			},
		},
		{
			path: '/team-edit/:teamId',
			name: 'team-edit',
			component: () => import('./views/TeamEdit.vue'),
			meta: {
				requireAuth: true,
				title: 'チームを作る',
				icon: 'team',
			},
		},
		{
			path: '/about',
			name: 'about',
			component: () => import('./views/About.vue'),
			meta: {
				requireAuth: true,
				title: '7Coinsとは',
				icon: 'seven',
			},
		},
		{
			path: '/about/:token',
			name: 'app-about',
			component: () => import('./views/About.vue'),
			meta: {
				requireAuth: true,
				title: '7Coinsとは',
				icon: 'seven',
			},
		},
		{
			path: '/ranking',
			name: 'ranking',
			component: () => import('./views/Ranking.vue'),
			meta: {
				requireAuth: true,
				title: '順位',
				icon: 'crown',
			},
		},
		{
			path: '/ranking/:token',
			name: 'app-ranking',
			component: () => import('./views/Ranking.vue'),
			meta: {
				requireAuth: true,
				title: '順位',
				icon: 'crown',
			},
		},
		{
			path: '/prize',
			name: 'prize',
			component: () => import('./views/Prize.vue'),
			meta: {
				requireAuth: true,
				title: '景品交換',
				icon: 'gift',
			},
		},
		{
			path: '/prize/:token',
			name: 'app-prize',
			component: () => import('./views/Prize.vue'),
			meta: {
				requireAuth: true,
				title: '景品交換',
				icon: 'gift',
			},
		},
		{
			path: '/history',
			name: 'history',
			component: () => import('./views/History.vue'),
			meta: {
				requireAuth: true,
				title: '獲得履歴',
				icon: 'clock',
			},
		},
		{
			path: '/history/:token',
			name: 'app-history',
			component: () => import('./views/History.vue'),
			meta: {
				requireAuth: true,
				title: '獲得履歴',
				icon: 'clock',
			},
		},
		{
			path: '/coin-present',
			name: 'coin-present',
			component: () => import('./views/CoinPresent.vue'),
			meta: {
				requireAuth: true,
				title: 'コインを贈る',
				icon: 'coin',
			},
		},
		{
			path: '/coin-present/:token',
			name: 'app-coin-present',
			component: () => import('./views/CoinPresent.vue'),
			meta: {
				requireAuth: true,
				title: 'コインを贈る',
				icon: 'coin',
			},
		},
		{
			path: '/coin-present-to-staff/:staffId',
			name: 'coin-present-to-staff',
			component: () => import('./views/CoinPresentTo.vue'),
			meta: {
				requireAuth: true,
				title: 'コインを贈る',
				icon: 'coin',
			},
		},
		{
			path: '/coin-present-to-team/:teamId',
			name: 'coin-present-to-team',
			component: () => import('./views/CoinPresentTo.vue'),
			meta: {
				requireAuth: true,
				title: 'コインを贈る',
				icon: 'coin',
			},
		},
		{
			path: '/coin-present-to/:coinPresentId',
			name: 'coin-present-to',
			component: () => import('./views/CoinPresentTo.vue'),
			meta: {
				requireAuth: true,
				title: 'コインを贈る',
				icon: 'coin',
			},
		},
		{
			path: '/information/:informationId',
			name: 'information',
			component: () => import('./views/Information.vue'),
			meta: {
				requireAuth: true,
				title: 'お知らせ',
				icon: 'news',
			},
		},
		{
			path: '/7coins/:coinPresentId',
			name: '7coins',
			component: () => import('./views/SevenCoins.vue'),
			meta: {
				requireAuth: true,
				title: '7Coins',
				icon: 'seven',
			},
		},
		{
			path: '/staff-edit',
			name: 'staff-edit',
			component: () => import('./views/StaffEdit.vue'),
			meta: {
				requireAuth: true,
				title: '設定',
				icon: 'gear',
			},
		},
		{
			path: '/notification',
			name: 'notification',
			component: () => import('./views/Notification.vue'),
			meta: {
				requireAuth: true,
				title: 'メール通知',
				icon: 'bell',
			},
		},
		{
			path: '/team-talk',
			name: 'team-talk',
			component: () => import('./views/TeamTalk.vue'),
			meta: {
				requireAuth: true,
				title: 'チームトーク',
				icon: 'balloon',
			},
		},
		{
			path: '/team-talk/:token',
			name: 'app-team-talk',
			component: () => import('./views/TeamTalk.vue'),
			meta: {
				requireAuth: true,
				title: 'チームトーク',
				icon: 'balloon',
			},
		},
		{
			path: '/team-talk/:token/:teamId',
			name: 'team-talk-view',
			component: () => import('./views/TeamTalk.vue'),
			meta: {
				requireAuth: true,
				title: 'チームトーク',
				icon: 'balloon',
			},
		},
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			store.commit('basic', {
				key: 'savedScrollPositionY',
				value: savedPosition.y,
			});
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve(savedPosition);
				}, 500);
			});
		} else {
			store.commit('basic', {
				key: 'savedScrollPositionY',
				value: 0,
			})
			return { x: 0, y: 0 }
		}
	}
})

router.beforeEach((to, from, next) => {
	const utils = new Utils(process.env.VUE_APP_IS_DEBUG)
	//console.log('router.beforeEach');
	//console.log(to.name);
	//console.log(utils.isApp());

	store.commit('basic', {
		key: 'isNavBarShow',
		value: !utils.isApp(),
	})

	store.commit('basic', {
		key: 'isFloatingMenuShow',
		value: true,
	})

	store.commit('basic', {
		key: 'isNavBarMenuShow',
		value: true,
	})

	if (utils.isApp()) {
		//console.log(to.name);
		//console.log(to.params);
		let names = [
			'app-top',
			'app-about',
			'app-news',
			'app-ranking',
			'app-prize',
			'app-coin-present',
			'app-my-page',
			'app-history',
			'app-team-new',
			'app-news-new',
			'app-team-talk',
		];
		for (let n in names) {
			if (to.name === names[n] && to.params.token) {
				let token = to.params.token;
				let auth = {};
				auth.token = token;

				store.commit('basic', {
					key: 'auth',
					value: auth,
				});

				next();
				return;
			}
		}
	}

	//let isNext = false;
	if (to.matched.some(record => record.meta.requireAuth)) {
		// 認証トークン存在チェック
		if (!store.state.auth || !store.state.auth.token) {
			//console.log('login');
			if (utils.isApp()) {
				next('/7coinsapplogout');
				return;
			} else {
				next({ path: '/login' });
				return;
			}
		}
	}

	next();
})

export default router;
